var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgPlayNoCircle = function SvgPlayNoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.19 6.87L2.708.94a1.321 1.321 0 00-.704-.204C1.308.737.667 1.29.667 2.072v11.855c0 .782.642 1.336 1.336 1.336.236 0 .478-.064.704-.205L12.19 9.13a1.332 1.332 0 000-2.26zM2 13.926l.005-11.852L11.484 8 2 13.927z",
    fill: "#fff"
  })));
};
export default SvgPlayNoCircle;